<script>
    import MainTitle from "../atoms/MainTitle.svelte";
    import { store } from "../store";
    import AccueilPortfolio from "../organisms/AccueilPortfolio.svelte";
    let subPortfolio = [];

    store.subscribe(value => {
        if(value != null){
            if(value.accueil !== undefined){
                subPortfolio = value.accueil;
            }
        }
    })

</script>

<MainTitle title="Accueil"/>
<AccueilPortfolio bind:subPortfolio = {subPortfolio} />